import React from 'react';
import {
  HouseDetail
} from '../../component/common'

function WebDetail() {

  return (
    <div className=' bg-white flex justify-center'>
      <div className='flex justify-center border border-form-bg bg-form-bg shadow-base'>
        <div className=' w-[70vw] mr-[12px] max-w-[1162px] min-w-[768px]'>
          <HouseDetail pClassName=' w-[100%] bg-white' />
        </div>
        <div className=' w-[400px] h-[100vh] bg-white flex-shrink-0'>
          <iframe src='/webhome' className=' w-[100%] h-[100%] ' />
        </div>
      </div>
    </div>
  );
}

export default WebDetail;
